import { render, staticRenderFns } from "./ValueBox.vue?vue&type=template&id=57e59f9a&scoped=true&"
import script from "./ValueBox.vue?vue&type=script&lang=js&"
export * from "./ValueBox.vue?vue&type=script&lang=js&"
import style0 from "./ValueBox.vue?vue&type=style&index=0&id=57e59f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e59f9a",
  null
  
)

export default component.exports